import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/services/useServiceQueryKeys.ts
var t = e("services", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as serviceQueryKeys };
